'use strict'
import { AppData} from "@/models/app-data"
import { Vue } from 'vue-property-decorator';

export class AppService {

  getAppData(): AppData {
    let appData!: AppData;

    if (Vue.$cookies != undefined) {
      appData = Vue.$cookies.get('appData') as AppData;
    }
    return appData;
  }

  saveAppData(appData: AppData): void {
    if (Vue.$cookies != undefined) {
      Vue.$cookies.set('appData', appData);
    }
  }

  deleteAppData(): void {
    if (Vue.$cookies != undefined) {
      Vue.$cookies.remove('appData');
    }
  }
}